import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RecaptchaModule } from 'ng-recaptcha';
import { InlineErrorModule } from '@app/shared/components/inline-error/inline-error.module';
import { LoadingModule } from '@app/shared/components/loading/loading.module';
import { PreventAutocompleteDirective } from '@app/shared/directives/prevent-autocomplete.directive';

@NgModule({
  imports: [CommonModule, TranslateModule, RecaptchaModule, InlineErrorModule, LoadingModule],
  declarations: [PreventAutocompleteDirective],
  exports: [TranslateModule, CommonModule, RecaptchaModule, PreventAutocompleteDirective],
})
export class SharedModule {}
